{
    "generic": "Si è verificato un errore. Riprovi.",
    "notFound": "Non abbiamo trovato quello che stava cercando."
}
